import { object } from "yup"
import email from "@/core/validation/email"

export default object({
  email,
})
